let videoAbortController = new AbortController(); // Global abort controller
const videoNotFound = document.getElementById("video-not-found");


document.addEventListener("DOMContentLoaded", function () {
  const videoElement = document.getElementById("product-video");
  const loader = document.getElementById("video-loader");

  let isDragging = false;
  let startX = 0;
  let startTime = 0;
  let wasPlaying = false;
  let lastUpdateTime = 0;
  const sensitivity = {
    desktop: 0.05, // Sensitivity for mouse
    mobile: 0.08, // Adjusted for smoother mobile dragging
  };
  const debounceInterval = 16; // ~60fps (16ms per frame)

  if (videoElement) {
    videoElement.controls = false; // Hide default controls

    // Ensure video metadata is loaded before dragging
    videoElement.addEventListener("loadedmetadata", () => {
      if (!videoElement.duration) {
        console.warn("Video duration not available");
      }
    });

    // Mouse Events
    videoElement.addEventListener("mousedown", startDragging);
    window.addEventListener("mousemove", handleDragging, { passive: false });
    window.addEventListener("mouseup", stopDragging);

    // Touch Events
    videoElement.addEventListener("touchstart", startDragging, {
      passive: false,
    });
    window.addEventListener("touchmove", handleDragging, { passive: false });
    window.addEventListener("touchend", stopDragging);

    // Start Dragging (Mouse or Touch)
    function startDragging(event) {
      if (videoElement.duration === 0 || isNaN(videoElement.duration)) {
        return; // Prevent dragging until metadata is loaded
      }
      isDragging = true;
      startX =
        event.type === "touchstart" ? event.touches[0].clientX : event.clientX;
      startTime = videoElement.currentTime;
      wasPlaying = !videoElement.paused;

      videoElement.pause(); // Pause immediately on drag
      event.preventDefault(); // Prevent scrolling/zooming
      document.body.style.cursor =
        event.type === "mousedown" ? "grab" : "default";
    }

    // Handle Dragging (Mouse or Touch)
    function handleDragging(event) {
      if (!isDragging) return;

      const now = performance.now();
      if (now - lastUpdateTime < debounceInterval) {
        return; // Skip if too soon
      }
      lastUpdateTime = now;

      const clientX =
        event.type === "touchmove" ? event.touches[0].clientX : event.clientX;
      const deltaX = clientX - startX;
      const currentSensitivity =
        event.type === "touchmove" ? sensitivity.mobile : sensitivity.desktop;
      const newTime = startTime + deltaX * currentSensitivity;

      // Update video time within bounds
      requestAnimationFrame(() => {
        if (isDragging) {
          videoElement.currentTime = Math.max(
            0,
            Math.min(newTime, videoElement.duration)
          );
        }
      });

      event.preventDefault(); // Prevent scrolling/zooming on touch
    }

    // Stop Dragging (Mouse or Touch)
    function stopDragging() {
      if (!isDragging) return;

      isDragging = false;
      document.body.style.cursor = "default";

      if (wasPlaying) {
        videoElement.play().catch((error) => {
          console.error("Error resuming video:", error);
        });
      }
    }

    // Prevent default touch behavior on video element
    videoElement.addEventListener(
      "touchstart",
      (event) => {
        event.stopPropagation();
      },
      { passive: false }
    );
  }

  // Function to get URL parameters
  function getUrlParameter(name) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name);
  }

  // Function to find the variant by ID
  // function findVariantById(variantId) {
  //   return productVariants.find((variant) => variant.id == variantId);
  // }

  function updateProductVideo(videoUrl) {
    const videoContainer = document.getElementById("video-container");
    const video360Icon = document.getElementById("video-360-icon");
    if (!videoElement || !videoUrl) {
      handleInvalidVideo();
      return;
    }

    videoAbortController.abort();
    videoAbortController = new AbortController();

    loader.style.display = "block";

    const tempVideo = document.createElement("video");
    tempVideo.src = videoUrl;

    tempVideo.onloadeddata = function () {
      videoContainer.style.display = "block";
      const videoSource = videoElement.querySelector("source");
      videoSource.src = videoUrl;
      videoElement.load();

      videoElement.oncanplay = function () {
        loader.style.display = "none";
        video360Icon.style.display = "block";
        videoElement.play().catch((error) => {
          console.error("Error playing video:", error);
        });
      };
    };

    tempVideo.onerror = function () {
      handleInvalidVideo();
    };

    function handleInvalidVideo() {
      loader.style.display = "none";
      videoContainer.style.display = "none";
      console.error("Invalid or unsupported video:", videoUrl);
    }
  }

  // Function to handle variant change
  function handleVariantChange() {
    const videoContainer = document.getElementById("video-container");
    videoNotFound.style.display = "none";

    const variantId = getUrlParameter("variant");
    // let selectedVariant = variantId
    //   ? findVariantById(variantId)
    //   : productVariants[0];

    // if (!selectedVariant) return;

    // ✅ DIRECT VIDEO FROM VARIANT METAFIELD
    const videoUrl = window.variant360Videos?.[variantId] || "";
    // const videoUrl = document.getElementById("360_video_link").innerHTML.trim();
    // console.log("Variant video URL:", videoUrl);

    if (videoUrl) {
      updateProductVideo(videoUrl);
    } else {
      videoContainer.style.display = "none";
      loader.style.display = "none";
      videoNotFound.style.display = "flex";
    }
  }

  // Initial video setup
  handleVariantChange();

  // Listen for URL changes (back/forward navigation)
  window.addEventListener("_support", handleVariantChange);

  // Listen for query parameter changes dynamically
  const observer = new MutationObserver(() => {
    const currentVariantId = getUrlParameter("variant");
    if (currentVariantId !== lastVariantId) {
      lastVariantId = currentVariantId;
      handleVariantChange();
    }
  });

  let lastVariantId = getUrlParameter("variant");
  observer.observe(document, { subtree: true, childList: true });

  // Cleanup event listeners on page unload
  window.addEventListener("unload", () => {
    window.removeEventListener("mousemove", handleDragging);
    window.removeEventListener("mouseup", stopDragging);
    window.removeEventListener("touchmove", handleDragging);
    window.removeEventListener("touchend", stopDragging);
    window.removeEventListener("popstate", handleVariantChange);
  });
});
